/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elastic_Gallery_Item_02_TitleInputs */

const en_elastic_gallery_item_02_title = /** @type {(inputs: Elastic_Gallery_Item_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urban Brutalism`)
};

const ar_elastic_gallery_item_02_title = /** @type {(inputs: Elastic_Gallery_Item_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وحشية حضرية`)
};

const bn_elastic_gallery_item_02_title = /** @type {(inputs: Elastic_Gallery_Item_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আরবান ব্রুটালিজম`)
};

const de_elastic_gallery_item_02_title = /** @type {(inputs: Elastic_Gallery_Item_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urbaner Brutalismus`)
};

const es_elastic_gallery_item_02_title = /** @type {(inputs: Elastic_Gallery_Item_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brutalismo urbano`)
};

const fr_elastic_gallery_item_02_title = /** @type {(inputs: Elastic_Gallery_Item_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brutalisme urbain`)
};

const pt_elastic_gallery_item_02_title = /** @type {(inputs: Elastic_Gallery_Item_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brutalismo urbano`)
};

const zh_elastic_gallery_item_02_title = /** @type {(inputs: Elastic_Gallery_Item_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`城市粗野主义`)
};

const tr_elastic_gallery_item_02_title = /** @type {(inputs: Elastic_Gallery_Item_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kentsel Brütalizm`)
};

const ru_elastic_gallery_item_02_title = /** @type {(inputs: Elastic_Gallery_Item_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Городской брутализм`)
};

const pl_elastic_gallery_item_02_title = /** @type {(inputs: Elastic_Gallery_Item_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miejski brutalizm`)
};

/**
* | output |
* | --- |
* | "Urban Brutalism" |
*
* @param {Elastic_Gallery_Item_02_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const elastic_gallery_item_02_title = /** @type {((inputs?: Elastic_Gallery_Item_02_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elastic_Gallery_Item_02_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_elastic_gallery_item_02_title(inputs)
	if (locale === "bn") return bn_elastic_gallery_item_02_title(inputs)
	if (locale === "de") return de_elastic_gallery_item_02_title(inputs)
	if (locale === "es") return es_elastic_gallery_item_02_title(inputs)
	if (locale === "fr") return fr_elastic_gallery_item_02_title(inputs)
	if (locale === "pt") return pt_elastic_gallery_item_02_title(inputs)
	if (locale === "zh") return zh_elastic_gallery_item_02_title(inputs)
	if (locale === "tr") return tr_elastic_gallery_item_02_title(inputs)
	if (locale === "ru") return ru_elastic_gallery_item_02_title(inputs)
	if (locale === "pl") return pl_elastic_gallery_item_02_title(inputs)
	return en_elastic_gallery_item_02_title(inputs)
});